import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";
import { installAxiosInterceptors } from "./http/axiosSetup";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { useDispatch, useSelector } from "react-redux";
import { store } from "./store/store";

import { Provider } from "react-redux";
const root = ReactDOM.createRoot(document.getElementById("root"));

installAxiosInterceptors();

/*
Sentry.init({
  dsn: "https://6ac4902002c955c3d29c9e2e8a78c01b@o4505147932344320.ingest.sentry.io/4506597835735040",
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    }),
    new Sentry.Replay({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


*/

root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
